import { getApis } from 'library/Apis';
import { isAuthenticated } from 'services/AuthService';
import api from 'services/api';
import SnackbarUtils from 'utils/SnackbarUtils';

export const FETCH_NOTIFICATIONS_REQUEST = 'FETCH_NOTIFICATIONS_REQUEST';
export const FETCH_NOTIFICATIONS_SUCCESS = 'FETCH_NOTIFICATIONS_SUCCESS';
export const FETCH_NOTIFICATIONS_FAILURE = 'FETCH_NOTIFICATIONS_FAILURE';
export const SET_TOTAL_PAGES = 'SET_TOTAL_PAGES';
export const SET_CURRENT_PAGE = 'SET_CURRENT_PAGE';
export const SET_ITEM_PER_PAGES = 'SET_ITEM_PER_PAGES';
export const SET_TOTAL_NOTIFICATIONS = 'SET_TOTAL_NOTIFICATIONS';
export const SHOW_LOADER = 'SHOW_LOADER';
export const HIDE_LOADER = 'HIDE_LOADER';
export const DELETE_NOTIFICATION = 'DELETE_NOTIFICATION';
export const CLEAR_NOTIFICATIONS = 'CLEAR_NOTIFICATIONS';

export const fetchNotificationsRequest = () => ({
  type: FETCH_NOTIFICATIONS_REQUEST,
});

export const fetchNotificationsSuccess = (notifications) => {
  localStorage.setItem('notificationCount', notifications.length.toString());
  return {
    type: FETCH_NOTIFICATIONS_SUCCESS,
    payload: notifications,
  };
};

export const fetchNotificationsFailure = (error) => ({
  type: FETCH_NOTIFICATIONS_FAILURE,
  payload: error,
});

export const clearNotifications = () => ({
  type: CLEAR_NOTIFICATIONS,
});

export const clearNotificationsAsync = () => {
  return (dispatch) => {
    setTimeout(() => {
      dispatch(clearNotifications());
      localStorage.setItem('notificationCount', '0');
    }, 800);
  };
};

export const setTotalPages = (totalPages) => ({
  type: 'SET_TOTAL_PAGES',
  payload: totalPages,
});

export const setItemPerPage = (itemPerPage) => ({
  type: 'SET_ITEM_PER_PAGES',
  payload: itemPerPage,
});

export const setCurrentPage = (currentPage) => ({
  type: 'SET_CURRENT_PAGE',
  payload: currentPage,
});

export const setTotalNotifications = (totalNotifications) => ({
  type: 'SET_TOTAL_NOTIFICATIONS',
  payload: totalNotifications,
});

export const showLoader = () => ({
  type: SHOW_LOADER,
});

export const hideLoader = () => ({
  type: HIDE_LOADER,
});

const getEndpoint = (version) => {
  return getApis().apis.contrato + 'v' + version;
};

export const fetchNotifications = (currentPage = 0, itemPerPage = 4) => {
  return async (dispatch) => {
    if (!isAuthenticated()) {
      return;
    }
    dispatch(showLoader());
    dispatch(fetchNotificationsRequest());
    try {
      const url = `${getEndpoint(1)}/notificacao?page=${currentPage + 1}`;
      const response = await api.get(url);
      const { elements, totalElements, totalPages } = response.data;
      dispatch(fetchNotificationsSuccess(elements));
      dispatch(setCurrentPage(currentPage));
      dispatch(setItemPerPage(itemPerPage));
      dispatch(setTotalNotifications(totalElements));
      dispatch(setTotalPages(totalPages));
      dispatch(hideLoader());
    } catch (error) {
      dispatch(fetchNotificationsFailure(error.message));
      dispatch(hideLoader());
    }
  };
};

export const deleteNotifications = (notificationIds) => {
  return async (dispatch) => {
    try {
      const queryParams = notificationIds
        .map((id) => `idNotificacao=${id}`)
        .join('&');
      const urlDelete = `${getEndpoint(1)}/notificacao?${queryParams}`;
      await api.delete(urlDelete);
      dispatch({
        type: DELETE_NOTIFICATION,
        payload: notificationIds,
      });
      SnackbarUtils.success('Notificações excluídas com sucesso');
    } catch (error) {
      SnackbarUtils.error('Erro ao deletar notificações');
    }
  };
};
